var r = /\s/;
function a(t) {
  for (var e = t.length; e-- && r.test(t.charAt(e)); )
    ;
  return e;
}
export {
  a as default
};
